import { AbstractControl, ValidationErrors } from '@angular/forms';

export const futureDateValidator = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (control.value < today) {
    return { date_in_past: true };
  }

  return null;
};
